import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Icon from "./Icon";

export default function FAQAccordion({ faqs, dark = false }) {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <div className="space-y-3" data-testid="faq-accordion">
      {faqs.map((f, i) => {
        const open = openIndex === i;
        return (
          <div
            key={i}
            className={`overflow-hidden rounded-xl border transition-colors duration-200 ${
              dark
                ? open ? "border-white/25 bg-white/5" : "border-white/10 bg-transparent hover:border-white/20"
                : open ? "border-navy/25 bg-white shadow-sm" : "border-slate-200 bg-white hover:border-navy/20"
            }`}
          >
            <button
              onClick={() => setOpenIndex(open ? -1 : i)}
              aria-expanded={open}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5"
              data-testid={`faq-question-${i}`}
            >
              <span className={`text-sm font-semibold sm:text-base ${dark ? "text-white" : "text-navy-dark"}`}>{f.q}</span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                  open ? "bg-navy text-white" : dark ? "bg-white/10 text-white" : "bg-sand text-navy"
                }`}
              >
                <Icon name="ChevronDown" className={`h-4 w-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                >
                  <p className={`px-5 pb-5 text-sm leading-relaxed sm:px-6 sm:text-base ${dark ? "text-white/70" : "text-slate-600"}`} data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
